'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var defaultOrder = {
  FIRST: 'asc',
  '': 'asc',
  asc: 'desc',
  desc: ''
};

exports.default = defaultOrder;


//////////////////
// WEBPACK FOOTER
// ./~/reactabular-sort/dist/default_order.js
// module id = 337
// module chunks = 0